import React, { useState, useEffect } from "react";
// import axios from "axios";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/apiClient";
import { XCircleIcon } from "@heroicons/react/solid";
import { io } from "socket.io-client";
import UsersList from "../components/UsersList";

// import { Check } from "lucide-react";
// import UsersList from "../components/UsersList";

const socket = io.connect(`${process.env.REACT_APP_API_BASE_URL}`);

const AccesHorsPays = ({ user, enabled, checkGroupAdmin }) => {
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [message, setMessage] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [couleur, setcouleur] = useState("");
  const [emailUser, setEmailUser] = useState("");
  const [nomUser, setNomUser] = useState("");
  const [idUser, setIdUser] = useState("");
  const [matricule, setMatricule] = useState("");
  const [showReassignPopup, setShowReassignPopup] = useState(false);
  const [errorReassign, setErrorReassign] = useState("");

  const location = useLocation();
  const selectedForm = location.state?.selectedForm;
  const page = location.state?.page;
  const navigate = useNavigate();

  const currentStepComponent = "Etape1";
  const [formId, setFormId] = useState(
    location.state?.selectedForm?._id || null,
  );
  const [commentaire, setCommentaire] = useState("");

  // Function to generate numeroFormulaire
  const generateNumeroFormulaire = () => {
    const date = new Date();
    const yy = date.getFullYear().toString().slice(-2); // Get last two digits of the year
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Month (0-padded)
    const dd = String(date.getDate()).padStart(2, "0"); // Day (0-padded)
    const randomNumber = Math.floor(1000 + Math.random() * 9000); // Random 4-digit number

    return `CSV-AHP-${yy}${mm}${dd}${randomNumber}`;
  };
  const initialFormData = {
    numeroFormulaire:
      selectedForm?.numeroFormulaire || generateNumeroFormulaire(),
    dateSoumission: new Date().toISOString().split("T")[0],
    // files: [],

    pays: selectedForm?.pays || "",
    dateDepart: selectedForm?.dateDepart
      ? new Date(selectedForm.dateDepart).toISOString().split("T")[0]
      : "",
    dateArriver: selectedForm?.dateArriver
      ? new Date(selectedForm.dateArriver).toISOString().split("T")[0]
      : "",
    commentaires: selectedForm?.commentaires || "",
    traitant: selectedForm?.traitant || [],
    managerInfo: selectedForm?.managerInfo || {
      nom: "",
      email: "",
      userId: "",
      matricule: "",
      etatDemande: "",
    },
    eleveInfo: selectedForm?.eleveInfo || {
      nom: "",
      email: "",
      userId: "",
      matricule: "",
      ecole: "",
    },
    etatDemande: selectedForm?.etatDemande || "",
    accesVpn: selectedForm?.accesVpn || "",
    estPourEleve: selectedForm?.estPourEleve || "",
    SignatureElectronique: selectedForm?.SignatureElectronique || "non",
  };
  const [formData, setFormData] = useState(initialFormData);
  // 🔹 Now conditional rendering

  useEffect(() => {
    if (user && !selectedForm) {
      setFormData((prevData) => ({
        ...prevData,
        userId: user.id,
        nom: user.displayName,
        matricule: user.employeeId,
        courriel: user.mail,
        poste: user.jobTitle,
      }));
    }

    if (selectedForm) {
      if (
        (selectedForm.etatDemande !== "Brouillon" &&
          selectedForm.etatDemande !== "Rejeté" &&
          page !== "Mes taches") ||
        page === "Mes taches"
      ) {
        setIsReadOnly(true);
      }

      setFormData((prevData) => ({
        ...prevData,
        userId: selectedForm.userId,
        nom: selectedForm.nom,
        matricule: selectedForm.matricule,
        courriel: selectedForm.courriel,
        poste: selectedForm.poste,

        numeroFormulaire: selectedForm.numeroFormulaire,
        dateSoumission:
          selectedForm.etatDemande === "Brouillon"
            ? new Date().toISOString().split("T")[0]
            : selectedForm.dateSoumission || prevData.dateSoumission,

        pays: selectedForm?.pays || "",
        dateDepart: selectedForm?.dateDepart
          ? new Date(selectedForm.dateDepart).toISOString().split("T")[0]
          : "",
        dateArriver: selectedForm?.dateArriver
          ? new Date(selectedForm.dateArriver).toISOString().split("T")[0]
          : "",
        commentaires: selectedForm?.commentaires || "",
        traitant: selectedForm?.traitant || [],
        managerInfo: selectedForm?.managerInfo || {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          etatDamande: "",
        },
        eleveInfo: selectedForm?.eleveInfo || {
          nom: "",
          email: "",
          userId: "",
          matricule: "",
          ecole: "",
        },
        etatDemande: selectedForm?.etatDemande || "",
        accesVpn: selectedForm?.accesVpn || "",
        estPourEleve: selectedForm?.estPourEleve || "",
        SignatureElectronique: selectedForm?.SignatureElectronique || "non",

        // files:
        //   selectedForm.files?.map((file) => {
        //     const base64Data = `data:${file.contentType};base64,${file.data}`;
        //     return base64ToFile(
        //       base64Data,
        //       file.filename,
        //       file.contentType,
        //       file._id
        //     );
        //   }) || [],
      }));
    }
  }, [user, selectedForm, page]); // Add selectedForm to the dependency array

  // État pour stocker les données du formulaire

  function getTraite(selectedForm, user, checkGroupAdmin) {
    // Cas admin
    if (selectedForm) {
      if (checkGroupAdmin) return true;

      // Cas traitant actuel
      if (
        selectedForm.traitant[selectedForm.traitant.length - 1]?.userId ===
        user.id
      ) {
        return true;
      }
    }

    return false;
  }

  // puis dans ton composant
  const traite = getTraite(selectedForm, user, checkGroupAdmin);

  const handleUserSelect = (user, fieldName) => {
    handleChange({
      target: {
        name: fieldName,
        value: {
          nom: user.displayName,
          email: user.mail,
          userId: user.id,
          matricule: user.employeeId,
          ecole: user.officeLocation,
          etatDemande: "",
        },
      },
    });
  };

  const handleUserSelectReassigner = (user) => {
    setErrorReassign("");
    setNomUser(user.displayName);
    setEmailUser(user.mail);
    setIdUser(user.id);
    setMatricule(user.employeeId);
  };

  // HandleChange générique
  const handleChangeCheckBox = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "oui" : "non") : value,
    }));
  };

  const handleChange = (e) => {
  let { name, value } = e.target;
  setErrors("");

  setFormData((prevData) => {
    // Gestion téléphone
    if (name === "numeroTelephone") {
      value = value.replace(/[^0-9]/g, "");
      if (value.length > 10) value = value.slice(0, 10);
    }

    let updatedData = { ...prevData, [name]: value };

    // 🔥 AJOUT ICI
    if (name === "estPourEleve" && value === "non") {
      updatedData.eleveInfo = {
        nom: "",
        email: "",
        userId: "",
        matricule: "",
        ecole: "",
        etatDemande: "",
      };
    }

    return updatedData;
  });
};

  // const handleChange = (e) => {
  //   let { name, value } = e.target;
  //   setErrors("");
  //   setFormData((prevData) => {
  //     if (name === "numeroTelephone") {
  //       // Remove any non-numeric characters (allow only digits)
  //       value = value.replace(/[^0-9]/g, "");

  //       // Limit the phone number to 10 digits
  //       if (value.length > 10) {
  //         value = value.slice(0, 10);
  //       }
  //     }
  //     // Mise à jour des autres champs
  //     return {
  //       ...prevData,
  //       [name]: value,
  //     };
  //   });
  // };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nom) {
      newErrors.nom = "Ce champ est requis.";
    }

    if (!formData.courriel) {
      newErrors.courriel = "Ce champ est requis.";
    }
    if (!formData.poste) {
      newErrors.poste = "Ce champ est requis.";
    }

    if (!formData.estPourEleve) {
      newErrors.estPourEleve = "Ce champ est requis.";
    }

    if (!formData.pays) {
      newErrors.pays = "Ce champ est requis.";
    }
    if (!formData.dateDepart) {
      newErrors.dateDepart = "La date est obligatoire.";
    }
    if (!formData.dateArriver) {
      newErrors.dateArriver = "La date est obligatoire.";
    } else if (formData.dateArriver <= formData.dateDepart) {
      newErrors.dateArriver =
        "La date de fin doit être ultérieure à la date de début.";
    } else {
      const depart = new Date(formData.dateDepart);
      const arriver = new Date(formData.dateArriver);

      const diffDays = (arriver - depart) / (1000 * 60 * 60 * 24);

      if (diffDays > 30) {
        newErrors.dateArriver =
          "La durée maximale entre les deux dates est de 30 jours.";
      }
    }

    if (!formData.accesVpn) {
      newErrors.accesVpn = "Ce champ est requis.";
    }
    if (formData.SignatureElectronique === "non") {
      newErrors.SignatureElectronique =
        "Veuillez accepter et signer électroniquement pour continuer.";
    }
    if (!formData.managerInfo.nom) {
      newErrors.managerInfo = "Ce champ est requis.";
    }
    if (formData.estPourEleve==="oui" && !formData.eleveInfo.nom) {
      newErrors.eleveInfo = "Ce champ est requis.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const validateFormEtapeApprobation = (action) => {
    const newErrors = {};

    if (action === "Rejeté" && !commentaire) {
      newErrors.commentaireApprobateur = `Veuillez indiquer la raison du rejet dans un commentaire.`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const renderError = (field) => {
    return errors[field] ? (
      <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errors[field]}
      </p>
    ) : null;
  };

  const handleFormAction = async (e, actionType, next = false) => {
    e.preventDefault();

    // Set dateSoumission to the current date and time in local timezone
    const currentDate = new Date();

    let updatedTraitant = [...(formData.traitant || [])];

    let updatedFormData = {
      ...formData,
      traitant: updatedTraitant,
      managerInfo: { ...formData.managerInfo },
      etatDemande: formData.etatDemande,
    };

    // =========================
    // ✅ APPROUVÉ
    // =========================
    if (actionType === "Approuvé") {
      updatedTraitant.push({
        userId: user.id,
        nom: user.displayName,
        email: user.mail,
        etatDemande: "Approuvé",
        dateHeure: currentDate,
        commentaire: commentaire,
      });

      const managerAlreadyApproved =
        formData.managerInfo?.etatDemande === "Approuvé";

      if (!managerAlreadyApproved) {
        // STEP 1 → manager approves

        updatedFormData.etatDemande = "En traitement";

        // ✅ garder le manager comme manager
        updatedFormData.managerInfo = {
          ...formData.managerInfo,
          etatDemande: "Approuvé",
        };

        // 🔥 ajouter le next uniquement dans traitant
        const nextUser = {
          userId: "b96a03cd-85d2-42b5-98a2-ef8c6b3a8ccb",
          nom: "Benosmane, Riad",
          email: "benosmaner@CSViamonde.ca",
          etatDemande: "En traitement",
          dateHeure: currentDate,
        };

        updatedTraitant.push(nextUser);
      } else {
        // FINAL APPROVAL
        updatedFormData.etatDemande = "Approuvé";
      }
    }

    // =========================
    // ❌ REJETÉ
    // =========================
    else if (actionType === "Rejeté") {
      updatedTraitant.push({
        userId: user.id,
        nom: user.displayName,
        email: user.mail,
        etatDemande: "Rejeté",
        dateHeure: currentDate,
        commentaire: commentaire,
      });

      updatedFormData.etatDemande = "Rejeté";

      updatedFormData.managerInfo = {
        ...formData.managerInfo,
        etatDemande: "",
      };
    }

    // =========================
    // 🔁 RÉASSIGNÉ
    // =========================
    else if (actionType === "Réassignée") {
      const managerWasApproved =
        formData.managerInfo?.etatDemande === "Approuvé";

      updatedTraitant.push({
        userId: user.id,
        nom: user.displayName,
        email: user.mail,
        etatDemande: "Réassignée",
        dateHeure: currentDate,
        commentaire: commentaire,
      });

      updatedTraitant.push({
        userId: idUser,
        matricule,
        nom: nomUser,
        email: emailUser,
        etatDemande: "En traitement",
        dateHeure: currentDate,
      });

      if (!managerWasApproved) {
        updatedFormData.managerInfo = {
          userId: idUser,
          matricule,
          nom: nomUser,
          email: emailUser,
          etatDemande: "En traitement",
        };
      }

      updatedFormData.etatDemande = "En traitement";
    }

    // =========================
    // 🔄 EN TRAITEMENT (SUBMIT)
    // =========================
    else if (actionType === "En traitement") {
      const newTraitant = {
        userId: formData.managerInfo.userId,
        nom: formData.managerInfo.nom,
        email: formData.managerInfo.email,
        matricule: formData.managerInfo.matricule,
        etatDemande: "En traitement",
        commentaire: "",
        dateHeure: currentDate,
      };

      updatedTraitant.push(newTraitant);

      updatedFormData.managerInfo = {
        ...formData.managerInfo,
        etatDemande: "En traitement",
      };

      updatedFormData.etatDemande = "En traitement";
    }

    // =========================
    // 📝 BROUILLON / AUTRES
    // =========================
    else {
      updatedFormData.etatDemande = actionType;
    }

    // 🔥 FINAL UPDATE
    updatedFormData.traitant = updatedTraitant;

    updatedFormData.dateSoumission =
      page === "Mes taches"
        ? formData.dateSoumission
        : currentDate.toISOString();

    // =========================
    // 🚀 API CALL
    // =========================

    const method = formId ? "PUT" : "POST";
    const formType = "AccesHP";
    const url = formId
      ? `${process.env.REACT_APP_API_BASE_URL}/form/${formId}?form=${formType}`
      : `${process.env.REACT_APP_API_BASE_URL}/form?form=${formType}`;

    // ✅ AJOUT ICI
    updatedFormData.action = actionType;

    try {
      const response = await apiFetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        const data = await response.json();
        setIsSubmitted(true); // Show popup
        // Hide popup after 3 seconds
        await new Promise((resolve) => {
          setTimeout(() => {
            setIsSubmitted(false); // Hide the popup after timeout
            resolve(); // Resolve the promise after 3 seconds
          }, 2000);
        });

        // Store the ID if this was a new form
        if (!formId && data.form?._id) {
          setFormId(data.form._id);
        }

        if (updatedFormData.etatDemande !== "Brouillon") {
          if (socket) {
            socket.emit("requestUpdated");
          }
        }

        if (
          updatedFormData.etatDemande !== "Brouillon" &&
          updatedFormData.etatDemande !== ""
        ) {
          if (page === "Mes taches") {
            navigate("/taches", { state: { selectedForm: null } });
          } else {
            navigate("/demande", { state: { selectedForm: null } });
          }
        }

        // navigate("/demande", { state: { selectedForm: null } });

        // console.log(`Form data ${actionType.toLowerCase()} successfully!`);
      } else {
        console.error(`Failed to ${actionType.toLowerCase()} form data.`);
      }
    } catch (error) {
      console.error(`Error ${actionType.toLowerCase()} form data:`, error);
    }
  };

  const handleSave = (e, next = false) => {
    handleFormAction(e, "Brouillon", next); // Use "Enregistrer" for save action
    setMessage(
      "Succès ! Le formulaire a été enregistré.\nVeuillez noter que l'enregistrement ne signifie pas que le formulaire a été soumis.",
    );
    setcouleur("text-grey-600");
    setErrors("");
  };
  const handleSubmit = (e) => {
    if (!validateForm()) return;
    handleFormAction(e, "En traitement"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été soumis.");
    setcouleur("text-green-600");
    setErrors("");
  };

  const handleApprouve = (e) => {
    handleFormAction(e, "Approuvé"); // Use "Enregistrer" for save action
    setMessage("Succès ! Le formulaire a été Approuvé.");
    setcouleur("text-green-600");
    setErrors("");
  };
  const handleRejeter = (e) => {
    if (!validateFormEtapeApprobation("Rejeté")) return;

    handleFormAction(e, "Rejeté"); // Use "Enregistrer" for save action
    setMessage("Le formulaire a été Rejeté.");
    setcouleur("text-red-700");
    setErrors("");
  };
  const handleReassign = (e) => {
    if (nomUser === "") {
      setErrorReassign("ce champs est requis");
    }
    // else if (nomUser === selectedForm.nom) {
    //   setErrorReassign("La demande ne peut pas être réassignée à son auteur.");
    // }
    else {
      setShowReassignPopup(false);
      handleFormAction(e, "Réassignée"); // Use "Enregistrer" for save action
      setMessage(`Succès ! Le formulaire a été Réassignée a ${nomUser}`);
      setcouleur("text-green-600");
      setErrors("");
    }
  };

  const handleReassignClick = () => {
    // if (!validateFormEtapeRH("Réassignée")) return;
    setShowReassignPopup(true);
  };
  const handleReassignCancel = () => {
    setShowReassignPopup(false);
    setNomUser("");
    setEmailUser("");
    setIdUser("");
    setMatricule("");
    setErrorReassign("");
  };

  function formatDate(dateInput) {
    try {
      if (!dateInput) return "Date invalide";
      // Si c'est déjà un objet Date valide
      if (dateInput instanceof Date && !isNaN(dateInput)) {
        return dateInput.toLocaleString("fr-CA", {
          dateStyle: "short",
          timeStyle: "short",
        });
      }
      // Sinon, on tente avec le constructeur Date
      const parsed = new Date(dateInput);
      // Si le constructeur ne fonctionne pas, on essaie avec Date.parse()
      if (isNaN(parsed)) {
        const timestamp = Date.parse(dateInput);
        if (!isNaN(timestamp)) {
          return new Date(timestamp).toLocaleString("fr-CA", {
            dateStyle: "short",
            timeStyle: "short",
          });
        } else {
          return "Date invalide";
        }
      }
      return parsed.toLocaleString("fr-CA", {
        dateStyle: "short",
        timeStyle: "short",
      });
    } catch (e) {
      return "Date invalide";
    }
  }
  const RadioQuestion = ({
    name,
    label,
    value,
    onChange,
    width = "full",
    messageErreur,
  }) => {
    return (
      <div className={`flex flex-col gap-2 w-[23%]`}>
        <label className="text-sm font-medium text-gray-900 ">
          {label} <span className="text-red-400 ml-1">*</span>
          
        </label>

        <div className="flex items-center gap-3">
          {["oui", "non"].map((option) => {
            const isSelected = value === option;

            return (
              <label
                key={option}
                className={`
                  flex items-center justify-center w-[80px]
                  px-4 py-2 rounded-lg cursor-pointer
                  text-sm font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
              >
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={isSelected}
                  onChange={onChange}
                  className="sr-only"
                  disabled={isReadOnly}
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </label>
            );
          })}
        </div>

        {messageErreur && (
          <div className="text-sm text-red-600">
            {renderError(messageErreur)}
          </div>
        )}
      </div>
    );
  };

  

  const getMaxDateArriver = () => {
    if (!formData.dateDepart) return "";

    const date = new Date(formData.dateDepart);
    date.setDate(date.getDate() + 30);

    return date.toISOString().split("T")[0];
  };

  // 🔒 Bloque le render tant que selectedForm n’est pas chargé
  if ((page === "Mes taches" || page === "Mes demandes") && !selectedForm) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
      </div>
    );
  }
  if (
    (!enabled && !selectedForm && page !== "Mes taches") ||
    (!enabled &&
      selectedForm &&
      selectedForm.etatDemande === "Brouillon" &&
      page !== "Mes taches")
  ) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-6 text-center">
        <XCircleIcon className="h-16 w-16 text-red-500 mb-4 animate-pulse" />
        <h3 className="text-2xl font-bold text-red-600 mb-2">
          Formulaire Accés hors pays fermé
        </h3>
        <p className="text-gray-700 max-w-md">
          Le formulaire est désormais fermé, car la période d’ouverture est
          terminée.
        </p>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen p-8 bg-gray-100 rounded-lg shadow-lg">
      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="numeroFormulaire"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de formulaire:
          </label>
          <input
            type="text"
            id="numeroFormulaire"
            name="numeroFormulaire"
            value={formData.numeroFormulaire}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
        </div>
      </div>

      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="dateEntreeEnVigueur"
            className="block text-sm font-medium text-blue-900"
          >
            Date :
          </label>
          <input
            type="date"
            id="dateSoumission"
            name="dateSoumission"
            value={formData.dateSoumission?.split("T")[0] ?? ""}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
        </div>
      </div>

      <div className="w-full flex justify-center mt-6 mb-20">
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
          <p className="text-md font-bold flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
              />
            </svg>
            Formulaire d'accés hors pays
          </p>
        </div>
      </div>
      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-blue-400 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          Information du membre du personnel
        </p>
      </div>
      <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
        <div className="w-3/5">
          <label
            htmlFor="nom"
            className="block text-sm font-medium text-blue-900"
          >
            Nom <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="text"
            id="nom"
            name="nom"
            value={formData.nom}
            required
            readOnly
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("nom")}
        </div>

        <div className="w-3/5">
          <label
            htmlFor="courriel"
            className="block text-sm font-medium text-blue-900"
          >
            Courriel <span className="text-xl text-red-900">*</span> :
          </label>
          <input
            type="text"
            id="courriel"
            name="courriel"
            value={formData.courriel}
            required
            readOnly
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("courriel")}
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
        <div className="w-3/5">
          <label
            htmlFor="poste"
            className="block text-sm font-medium text-blue-900"
          >
            Poste: <span className="text-xl text-red-900">*</span>:
          </label>
          <input
            type="text"
            id="poste"
            name="poste"
            value={formData.poste}
            readOnly
            onChange={handleChange}
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
          />
          {renderError("poste")}
        </div>
      </div>

      <div className="mt-16 grid gap-0">
        <RadioQuestion
          name="estPourEleve"
          label="Cette demande est-elle faite au nom d’un élève ?"
          value={formData.estPourEleve}
          onChange={handleChange}
          messageErreur={"estPourEleve"}
        />
      </div>

      {formData.estPourEleve !== "" && (
        <>
          {formData.estPourEleve === "oui" && (
            <>
            <div className="mt-10 w-full bg-blue-50 border-l-4 border-blue-400 px-4 py-3 rounded-r-lg">
              <p className="text-sm font-medium text-blue-700 flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-blue-400 mr-2 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                Information de l'élève
              </p>
            </div>
         

          <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
            <div className="w-3/5">
              <label
                className="block text-sm font-medium text-blue-900 mb-2"
              >
                Élève<span className="text-xl text-red-900">*</span> :
              </label>
              <div className="relative">
                {/* Add the UsersList component with the callback for user selection */}
                {isReadOnly === false && !formData?.eleveInfo?.nom &&(
                  <UsersList
                    onUserSelect={(user) => handleUserSelect(user, "eleveInfo")}
                    initialValue={formData?.eleveInfo?.email}
                    eleve="student"
                  />
                )}

                {/* Display the selected user's information */}
                {formData?.eleveInfo?.nom && (
                  <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.eleveInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.eleveInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.eleveInfo.email}
                      </span>
                      {formData.eleveInfo.ecole && (
                        <span className="text-sm text-blue-500">
                          {formData.eleveInfo.ecole}
                        </span>
                      )}
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            eleveInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              ecole: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </div>
              {renderError("eleveInfo")}
            </div>
          </div>
          </>
         )}

          <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-3/5">
              <label
                htmlFor="pays"
                className="block text-sm font-medium text-blue-900"
              >
                pays: <span className="text-xl text-red-900">*</span>:
              </label>
              <input
                type="text"
                id="pays"
                name="pays"
                value={formData.pays}
                readOnly={isReadOnly}
                onChange={handleChange}
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("pays")}
            </div>
          </div>

          <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
            <div className="w-3/5 ">
              <label
                htmlFor="dateDepart"
                className="block text-sm font-medium text-blue-900"
              >
                Date de départ<span className="text-xl text-red-900">*</span> :
              </label>
              <input
                type="date"
                id="dateDepart"
                name="dateDepart"
                value={formData.dateDepart}
                onChange={handleChange}
                readOnly={isReadOnly}
                min={new Date().toISOString().split("T")[0]}
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("dateDepart")}
            </div>
            <div className="w-3/5 ">
              <label
                htmlFor="dateArriver"
                className="block text-sm font-medium text-blue-900"
              >
                Date d'arriver'<span className="text-xl text-red-900">*</span> :
              </label>
              <input
                type="date"
                id="dateArriver"
                name="dateArriver"
                value={formData.dateArriver}
                min={
                  formData.dateDepart || new Date().toISOString().split("T")[0]
                }
                max={getMaxDateArriver()}
                onChange={handleChange}
                readOnly={isReadOnly}
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
              />
              {renderError("dateArriver")}
            </div>
          </div>

          <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
            <div className="w-3/5">
              <label
                htmlFor="fileUpload"
                className="block text-sm font-medium text-blue-900 mb-2"
              >
                {formData.estPourEleve ==="oui" ? "Surintendance" : "Superviseur"}<span className="text-xl text-red-900">*</span> :

                
              </label>
              <div className="relative">
                {/* Add the UsersList component with the callback for user selection */}
                {isReadOnly === false && !formData?.managerInfo?.nom && (
                  <UsersList
                    onUserSelect={(user) =>
                      handleUserSelect(user, "managerInfo")
                    }
                    initialValue={formData?.managerInfo?.email}
                  />
                )}

                {/* Display the selected user's information */}
                {formData?.managerInfo?.nom && (
                  <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {formData.managerInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.managerInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.managerInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            managerInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              ecole: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </div>
              {renderError("managerInfo")}
            </div>
          </div>

          <div className="mt-16 grid gap-0">
            <RadioQuestion
              name="accesVpn"
              label="Avez-vous besoin d’un accès VPN afin d’accéder aux systèmes internes (p. ex. SAP) ou aux lecteurs réseau ?"
              value={formData.accesVpn}
              onChange={handleChange}
              messageErreur={"accesVpn"}
            />
          </div>

          {/* Checkbox */}
          <div className="mt-10 p-5 bg-white rounded-2xl shadow-lg border border-gray-200">
            <label className="flex items-center cursor-pointer space-x-4 relative">
              {/* Hidden checkbox but still part of layout */}
              <input
                type="checkbox"
                name="SignatureElectronique"
                checked={formData.SignatureElectronique === "oui"}
                onChange={handleChangeCheckBox}
                className="absolute opacity-0 w-6 h-6"
                disabled={isReadOnly}
              />
              {/* Custom box */}
              <span
                className="flex items-center justify-center h-6 w-6 rounded-lg border-2 border-gray-300 bg-gray-50 transition-all duration-300 
      checked:border-blue-500 peer-checked:bg-blue-50"
              >
                {/* Check icon */}
                {formData.SignatureElectronique === "oui" && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={3}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </span>
              {/* Label text */}
              <span className="text-gray-900 font-medium text-sm select-none">
                Je certifie que les informations fournies sont exactes,
                complètes et vérifiées.
              </span>
              {renderError("SignatureElectronique")}
            </label>
          </div>
        </>
      )}

      {page === "Mes taches" && (
        <>
          {/* ===== SECTION RH - COMMUNE ===== */}
          <div className="mt-[5%] w-full">
            <div className="w-full h-1 bg-gray-500 mb-10"></div>
            <div className="bg-gradient-to-r from-blue-900 to-blue-900 py-4 shadow-lg rounded-t-2xl">
              <p className="text-xl font-bold text-white ml-4 tracking-wide flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-blue-300 mr-3"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.67 0-8 1.34-8 4v2h8v-2c0-.69.28-1.32.74-1.77C9.43 14.48 10.68 14 12 14c1.32 0 2.57.48 3.26 1.23.46.45.74 1.08.74 1.77v2h8v-2c0-2.66-5.33-4-8-4H8z" />
                </svg>
                Processus d’approbation
              </p>
            </div>
          </div>

          {/* ===== COMMENTAIRE RH (TOUS) ===== */}
          <div className="mt-10 w-3/4 grid grid-cols-2  gap-0">
            <div className="w-full mt-4">
              <label
                htmlFor="commentaireApprobateur"
                className="block text-sm font-medium text-blue-900"
              >
                Commentaire de l’approbateur:
              </label>
              <textarea
                placeholder="Ajoutez une qualification..."
                className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
                rows="5"
                id="commentaireApprobateur"
                name="commentaireApprobateur"
                value={commentaire}
                onChange={(e) => setCommentaire(e.target.value)}
                // readOnly={isReadOnlyRh}
              />
              {renderError("commentaireApprobateur")}
            </div>
          </div>
          {/* ===== TABLE COMMENTAIRES (TOUS) ===== */}
          <div className="mt-8 w-3/4">
            <h3 className="font-bold text-lg mb-4">Liste des commentaires :</h3>
            <div className="overflow-x-auto rounded-xl border">
              <table className="min-w-full bg-white divide-y">
                <thead className="bg-blue-600 text-white">
                  <tr>
                    <th className="p-3 text-left">Nom</th>
                    <th className="p-3 text-left">Courriel</th>
                    <th className="p-3 text-left">État</th>
                    <th className="p-3 text-left">Date</th>
                    <th className="p-3 text-left">Commentaire</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.traitant.map((note) => (
                    <tr key={note.id} className="hover:bg-gray-50">
                      <td className="p-3">{note.nom}</td>
                      <td className="p-3">{note.email}</td>
                      <td className="p-3">{note.etatDemande}</td>
                      <td className="p-3">{formatDate(note.dateHeure)}</td>
                      <td className="p-3 py-2 max-w-xs break-words whitespace-pre-wrap overflow-y-auto">
                        {note.commentaire}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      <div className="flex justify-start mt-16">
        <div className="flex gap-4">
          {(formData.etatDemande === "Brouillon" ||
            formData.etatDemande === "") && (
            <button
              type="button"
              className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-gray-700 text-white
          hover:bg-gray-600 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
              onClick={(e) => handleSave(e, false)}
            >
              Enregistrer
            </button>
          )}

          {currentStepComponent === "Etape1" &&
            (formData.etatDemande === "Brouillon" ||
              formData.etatDemande === "" ||
              (formData.etatDemande === "Rejeté" && page !== "Mes taches")) &&
            enabled && (
              <button
                type="button"
                className="
          flex items-center justify-center
          px-5 py-2.5 rounded-xl text-sm font-medium
          bg-green-600 text-white
          hover:bg-green-500 active:scale-95
          transition-all duration-200 shadow-sm hover:shadow-md w-24
        "
                onClick={handleSubmit}
              >
                Soumettre
              </button>
            )}

          {page === "Mes taches" &&
            selectedForm.etatDemande !== "Rejeté" &&
            selectedForm.etatDemande !== "Approuvé" &&
            traite && (
              <button
                type="button"
                className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-yellow-600 text-white
            hover:bg-yellow-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
                onClick={handleReassignClick}
              >
                Réassigner
              </button>
            )}
          {page === "Mes taches" &&
            selectedForm.etatDemande !== "Rejeté" &&
            selectedForm.etatDemande !== "Approuvé" &&
            traite && (
              <button
                type="button"
                className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-red-600 text-white
            hover:bg-red-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
                onClick={handleRejeter}
              >
                Rejeter
              </button>
            )}
          {page === "Mes taches" &&
            selectedForm.etatDemande !== "Rejeté" &&
            selectedForm.etatDemande !== "Approuvé" &&
            traite && (
              <button
                type="button"
                className="
            flex items-center justify-center
            px-5 py-2.5 rounded-xl text-sm font-medium
            bg-green-600 text-white
            hover:bg-green-500 active:scale-95
            transition-all duration-200 shadow-sm hover:shadow-md w-24
          "
                onClick={handleApprouve}
              >
                Approuver
              </button>
            )}
        </div>
      </div>

      {showReassignPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-1/3">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">
              Réassigner la tâche
            </h2>
            <label className="block mb-2 text-sm font-medium text-gray-600">
              Nom:
            </label>
            {!nomUser && (<UsersList onUserSelect={handleUserSelectReassigner}></UsersList>)}
            {errorReassign && (
              <p className="flex items-center gap-1.5 text-sm text-red-500 mt-1">
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-red-100 text-red-500 text-[10px] font-bold flex-shrink-0">
          !
        </span>
        {errorReassign}
      </p>
            )}
            {nomUser && (
                  <div className="mt-4 p-4 rounded-2xl border border-gray-200 shadow-sm bg-white flex items-center gap-4">
                    {/* Avatar */}
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-purple-100 text-purple-600 font-semibold text-lg">
                      {nomUser.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {nomUser}
                      </span>
                      <span className="text-sm text-gray-700">
                        {emailUser}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    
                      <button
                        onClick={() => {
                          setNomUser("");
                          setEmailUser("");
                          setIdUser("");
                          setMatricule("");
                          setErrorReassign("");
                        }}
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                  </div>
                )}
            <div className="flex justify-end mt-6 space-x-4">
              <button
                className="px-5 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
                onClick={handleReassignCancel}
              >
                Annuler
              </button>
              <button
                className="px-5 py-2 text-sm font-medium text-white bg-green-500 rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400"
                onClick={handleReassign}
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}

      {isSubmitted && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30">
          <div
            className={`flex items-center space-x-3 px-5 py-4 bg-white ${couleur} rounded-lg shadow-xl transform transition-all duration-500 ease-in-out animate-bounce`}
          >
            <CheckCircleIcon className={`h-8 w-8 ${couleur} animate-pulse`} />
            <span className="text-lg font-semibold">{message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccesHorsPays;
